export default __webpack_public_path__ + "static/media/redis.ec8971a9.svg";